module.exports = __webpack_public_path__ + "media/images/categories/carousel/management-6305bfff4ec60f5a7e6b2c588a98d967.jpg";